export const countChangedFields = (oldData: any, newData: any): number => {
  let count = 0;

  const compareValues = (oldValue: any, newValue: any, key: string) => {
    if (Array.isArray(oldValue) && Array.isArray(newValue)) {
      const isPrimitiveArray = (arr: any[]) =>
        arr.every(
          (item) =>
            typeof item === "string" ||
            typeof item === "number" ||
            typeof item === "boolean" ||
            item === null
        );

      if (isPrimitiveArray(oldValue) && isPrimitiveArray(newValue)) {
        if (
          oldValue.length !== newValue.length ||
          !oldValue.every((v, i) => v === newValue[i])
        ) {
          count += 1;
        }
        return;
      }
      const oldMap = new Map(oldValue.map((item) => [item?.id, item]));
      const newMap = new Map(newValue.map((item) => [item?.id, item]));

      // Detect removals
      oldMap.forEach((item, id) => {
        if (!newMap.has(id)) {
          count += 1;
        }
      });

      // Detect additions
      if (key.includes("Gallery")) {
        newMap.forEach((item, id) => {
          if (!oldMap.has(id)) {
            count += 1;
          }
        });
      } else {
        newMap.forEach((item, id) => {
          if (!oldMap.has(id)) {
            count += 1;
            const defaultItem = Object.fromEntries(
              Object.keys(item).map((key) => [
                key,
                shouldRetainValue(item[key])
                  ? item[key]
                  : getDefaultValue(item[key]),
              ])
            );
            compareValues(defaultItem, item, key); // Compare added item fields
          }
        });
      }

      // Compare existing items
      oldValue.forEach((item) => {
        const newItem = newValue.find((i) => i.id === item.id);
        if (newItem) {
          compareValues(item, newItem, "");
        }
      });
    } else if (
      typeof oldValue === "object" &&
      oldValue !== null &&
      newValue !== null &&
      !key.includes("Gallery")
    ) {
      const allKeys = new Set([
        ...Object.keys(oldValue || {}),
        ...Object.keys(newValue || {}),
      ]);
      allKeys.forEach((key) => {
        compareValues(oldValue[key] ?? null, newValue?.[key] ?? null, key);
      });
    } else if (oldValue !== newValue) {
      count++;
    }
  };

  compareValues(oldData || {}, newData || {}, "");
  return count;
};

const shouldRetainValue = (value: any): boolean => {
  if (typeof value === "string") {
    return isUUID(value) || isCountryCode(value);
  }
  return false;
};

const isUUID = (value: string): boolean => {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value
  );
};

const isCountryCode = (value: string): boolean => {
  return /^\+\d{1,4}$/.test(value);
};

const getDefaultValue = (value: any) => {
  if (Array.isArray(value)) return [];
  if (typeof value === "string") return "";
  if (typeof value === "number") return 0;
  if (typeof value === "boolean") return false;
  if (value && typeof value === "object") return {};
  return null;
};
